import React from 'react';
import cx from 'classnames';

export const NoiseError = ({ error }: any) => {
  return <div className={cx('noise-graph_container--error')}>{error}</div>;
};
